module.exports = __webpack_public_path__ + "img/mjkn_reporting_icon.ec264f46.svg";